/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import GlobalConfig from "../../context/GlobalConfig";
import { ArrowRightIcon, CheckIcon } from "@heroicons/react/24/solid";
import Footer from "../../components/Footer";
import Head from "../Head";
import { countries } from "../../constants/countries";
import { languageData } from "../../constants/languageData";
import { useParams } from "react-router-dom";
import JourneyConfig from "../../context/JourneyConfig";
import Loader from "../../components/Loader/Loader";
import RenderSvg from "../../components/RenderSvg";
import GoogleIcon from "../../components/GoogleIcon";

function Intro({ stepperFunc, steps, currentStep }) {
  const { journey, setJourney, getJourney, updateJourney } = useContext(JourneyConfig);
  const { config, setConfig } = useContext(GlobalConfig);
  const { branding } = config ?? {};
  const { processingConfig } = config ?? {};
  const [consentStatus, setConsentStatus] = useState(journey?.capturedData?.consent ?? false);
  const language = sessionStorage.getItem("language") ?? "en";
  const { journeyId } = useParams();
  const [loading, setLoading] = useState(true);
  const color = config?.branding?.accentColor;
  const [isOnlySelfieFlow,setIsOnlySelfieFlow] = useState(config?.documentCapture?.[0]?.required === false);
  const [isOnlyDocument,setIsOnlyDocumentFlow] = useState(config?.faceCapture?.required === false);
  const bgColor = "color-mix(in srgb, " + config?.branding?.accentColor + " 10%, white)";


  useEffect(() => {
    if (journey) {
      setJourney((prev) => ({
        ...prev,
        capturedData: { ...prev?.capturedData, consent: consentStatus },
      }));
    }
  }, [consentStatus]);

  useEffect(() => {
    let timer = setTimeout(() => {
      setLoading(false);
    }, 1000); 

    return () => clearTimeout(timer); 
  }, []);

  const moveToNextStep = async () => {
    const isPolicyLinkGiven = !!processingConfig?.privacyPolicyLink;
    
    if (
      (consentStatus) ||
      !processingConfig?.privacyPolicyLink
    ) {
      const countryCode = journey?.userInfo?.id?.country || "";
      const selectedCountry = countries.find((country) => country.value === countryCode);
      
      if (countryCode) {
        setConfig({
          ...config,
          branding: { ...branding, countrySelected: selectedCountry },
        });

        await updateJourney(
          "COUNTRY_SELECTION",
          {
            consent: isPolicyLinkGiven,
            country: countryCode
          },
          currentStep
        );
        
        stepperFunc(steps[0] + 1);
      } else {
        await updateJourney(
          "CONSENT",
          {
            consent: isPolicyLinkGiven
          },
          currentStep
        );

        stepperFunc(steps[0]);
      }
    }
};


  if (loading) {
    return <Loader />;
  }

  return (
    <>
    <Head
      style={{ zIndex: "100" }}
      stepperFunc={stepperFunc}
      showMobileFlow={false}
      showCountry={false}
      showBackIcon={false}
    />
    <div className="parent-container">
      <div className="main">
        <div className="left-section">
          <RenderSvg config={config} svgType={isOnlySelfieFlow ? "faceIntro":"introduction"} id={isOnlySelfieFlow ? "faceIntro":"introduction"} />
        </div>
        <div className="right-section md:items-start items-center"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: 24,
          }}
        >
          <div className="flex flex-col ">
            <div className="text-[18px] md:text-[24px] font-semibold text-[#000000] text-center md:text-start md:gap-[16px]">
              {isOnlySelfieFlow ?  languageData[language]?.introLiveness?.heading : (isOnlyDocument ? languageData[language]?.onlyIdVerificationHeader?.title : languageData[language]?.header?.title)}
            </div>
            <div className="mt-2 text-[12px] md:text-[14px] font-semibold text-[#656565] text-center md:text-start">
              {isOnlySelfieFlow ?  (languageData[language]?.introLiveness?.subHeading ?
                                languageData[language]?.introLiveness?.subHeading : `You're just one step away` ) : (isOnlyDocument ? languageData[language]?.onlyIdVerificationHeader?.subtitle : languageData[language]?.header?.subtitle)}
            </div>
          </div>

          <div className="flex flex-col mt-2 ">
            <div className="flex flex-col md:gap-[16px] gap-3">
              <div className="flex flex-row gap-[12px] md:w-[100%] items-center">
                <div>
                  <div className={`px-[8px] py-[8px] rounded-full`}
                    style={{
                      backgroundColor: bgColor,
                    }}
                  >
                    {(
                      <GoogleIcon
                        iconName={isOnlySelfieFlow ? "wb_sunny" : (isOnlyDocument ? "photo_camera":"credit_card")}
                        size={isOnlySelfieFlow || isOnlyDocument ? 20 : 24}
                        style={{ color: color }}
                      />
                    )}
                  </div>
                </div>
                <div className="text-[14px] text-[#656565] leading-[20px]">
                  {isOnlySelfieFlow ?  languageData[language]?.introLiveness?.instruction1 : (isOnlyDocument ? languageData[language]?.onlyIdVerificationHeader?.instruction1 : languageData[language]?.subHeading?.subHeading1)}
                </div>
              </div>

              <div className="flex flex-row gap-[12px] md:w-[100%] items-center">
                <div>
                  <div className={`px-[8px] py-[8px] rounded-full`}
                    style={{ backgroundColor: bgColor }}
                  >
                    <GoogleIcon
                      iconName="center_focus_weak"
                      size={isOnlySelfieFlow || isOnlyDocument ? 20 : 24}
                      style={{ color: color }}
                    />
                  </div>
                </div>
                <div
                  className="text-[14px] text-[#656565]"
                  style={{
                    fontWeight: 400,
                    color: "#656565",
                  }}
                >
                  {isOnlySelfieFlow ?  languageData[language]?.introLiveness?.instruction2 : (isOnlyDocument ? languageData[language]?.onlyIdVerificationHeader?.instruction2 : languageData[language]?.subHeading?.subHeading2)}
                </div>
              </div>
              {
                (isOnlySelfieFlow || isOnlyDocument) && (
                  <div className="flex flex-row gap-[12px] md:w-[100%] items-center">
                  <div>
                    <div
                      className={`px-[8px] py-[8px] rounded-full`}
                      style={{ backgroundColor: bgColor }}
                    >
                      <GoogleIcon
                        iconName={isOnlySelfieFlow ? "masks" : "check"}
                        size={isOnlySelfieFlow || isOnlyDocument ? 20 : 24}
                        style={{ color: color }}
                      />
                    </div>
                  </div>
                  <div
                    className="text-[14px] text-[#656565]"
                    style={{
                      fontWeight: 400,
                      color: "#656565",
                    }}
                  >
                    {isOnlySelfieFlow ? languageData[language]?.introLiveness?.instruction3 : languageData[language]?.onlyIdVerificationHeader?.instruction3}
                  </div>
                  </div>
                )
              }
            </div>
          </div>

          <div
            className="flex flex-col justify-center md:justify-end md:items-start items-center mt-[0.5rem] md:gap-[16px] w-full"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            {(
              <div className="flex flex-col justify-end items-start gap-[16px] md:px-[0px] px-[24px] w-full">
                <label
                  onClick={() =>
                    setConsentStatus(!consentStatus)
                  }
                  style={{
                    cursor: "pointer",
                    display: processingConfig?.privacyPolicyLink
                      ? "flex"
                      : "none",
                  }}
                  className="flex items-start gap-[12px]  self-stretch"
                >
                  <div
                    className="flex justify-center items-center"
                    style={{
                      border: "1px solid black",
                      width: 22,
                      height: 16,
                      borderRadius: 4,
                      background: consentStatus
                        ? color
                        : "none",
                    }}
                  >
                    <CheckIcon
                      width={12}
                      height={12}
                      color={"white"}
                      style={{
                        display: consentStatus
                          ? "block"
                          : "none",
                      }}
                    />
                  </div>
                  <span className="text-[12px]  text-[#656565]">
                    {languageData[language]?.termsAndCondition?.title}
                    &nbsp;
                    <a
                      href={processingConfig?.privacyPolicyLink}
                      className={`hover:underline`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: color }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {languageData[language]?.termsAndCondition?.privacyPolicy}
                    </a>
                  </span>
                </label>
                <div className="flex flex-col md:justify-end items-center md:gap-[12px] w-full">
                  <button
                    className="flex items-center justify-center  gap-[8px] w-full pt-[12px] pb-[12px] pr-[24px] pl-[24px] text-white rounded-[4px] text-[14px] font-medium"
                    style={{
                      backgroundColor:
                        processingConfig?.privacyPolicyLink &&
                        !consentStatus
                          ? bgColor
                          : color,
                    }}
                    disabled={
                      processingConfig?.privacyPolicyLink &&
                      !consentStatus
                    }
                    onClick={() => moveToNextStep()}
                  >
                    {languageData[language]?.termsAndCondition?.beginBtnText}
                    <ArrowRightIcon className="h-[16px] w-[16px]" />
                  </button>
                </div>
                <Footer />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </>

  )
}


export default Intro;
